'use client';

import React, { useState } from 'react';
import { PlaybackControl } from './PlaybackControl/PlaybackControl';
import SpeedChange from './SpeedChange';
import { Options } from './Options/Options';
import MetronomeSettings from './MetronomeSettings';
import { HandChange } from './HandChange';

import FragmentsTable from './Fragments/FragmentsTable';

import { Samples } from './Samples/Samples';

import ToggleMode from './ToggleMode';
import playbackControlModel from './PlaybackControl/PlaybackControlModel';
import { IconButton } from './ui/button';
import { PiEyeClosedThin, PiEyeThin } from 'react-icons/pi';
import SheetEditor from './XmlEditor';
import { isAdminPage } from '@/sharedTypes/helpers';
import TooltipBlindMode from './Tooltips/TooltipBlindMode';
import TooltipMetronome from './Tooltips/TooltipMetronome';
import TooltipHandChange from './Tooltips/TooltipHandChange';
import TooltipSpeedChange from './Tooltips/TooltipSpeedChange';

const BottomLine = () => {
  const [mode, setMode] = useState<'Play' | 'Practice'>('Practice');
  const blindMode = playbackControlModel.blindMode;

  return (
    <div className='px-1 lg:px-6 py-1 lg:py-2 z-[60] bg-white fixed bottom-0 left-0 right-0 border-t'>
      <div className='grid grid-cols-[3fr_1fr_3fr] items-center gap-0 sm:gap-2'>
        <div className='flex flex-nowrap items-center gap-1'>
          <Samples />

          {/* <FragmentsTable /> */}
          <ToggleMode mode={mode} setMode={setMode} />
          <TooltipHandChange>
            <div>
              <HandChange />
            </div>
          </TooltipHandChange>
          {isAdminPage() && <SheetEditor />}
        </div>
        <div>
          <PlaybackControl mode={mode} />
        </div>
        <div className='grid grid-cols-[1fr_auto] items-center justify-items-end gap-1'>
          <div className='hidden md:block landscape:block'>
            <TooltipBlindMode>
              <IconButton
                data-testid='trigger_blind_btn'
                onClick={playbackControlModel.triggerBlind.bind(
                  playbackControlModel
                )}
              >
                {blindMode ? (
                  // Closed eye icon when blind mode is active
                  <PiEyeClosedThin size={36} />
                ) : (
                  // Open eye icon when blind mode is inactive
                  <PiEyeThin size={36} />
                )}
              </IconButton>
            </TooltipBlindMode>
          </div>
          <div className='flex flex-nowrap items-center gap-0 sm:gap-1 justify-end max-sm:portrait:hidden'>
            <TooltipSpeedChange>
              <div>
                <SpeedChange mode={mode} />
              </div>
            </TooltipSpeedChange>
            <TooltipMetronome>
              <div>
                <MetronomeSettings />
              </div>
            </TooltipMetronome>
            <Options />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomLine;
